const facturationAddress = () => {
  const handleChange = () => {
    const facturationCheck = document.getElementById('facturation');
    const facturationBox = document.querySelector('.facturation_address');

    switch (facturationCheck.checked) {
      case true:
        facturationBox.classList.remove('edit');
        break;
      case false:
        facturationBox.classList.add('edit');
        break;
      default:
        // nothing
    }
  };

  const validForm = () => {
    // Todo
  };

  const cancelForm = (e) => {
    e.preventDefault();
    const formElement = document.getElementById('address-form');
    const inputs = formElement.querySelectorAll('input');
    const facturationCheck = document.getElementById('facturation');
    inputs.forEach(current => current.value = '');
    facturationCheck.checked = true;
    handleChange();
  };

  const init = () => {
    const facturationCheck = document.getElementById('facturation');
    const formElement = document.getElementById('address-form');
    const buttonCancel = document.getElementById('cancel');
    if (facturationCheck) {
      facturationCheck.addEventListener('change', handleChange);
      formElement.addEventListener('submit', validForm);
      buttonCancel.addEventListener('click', cancelForm);
      handleChange();
    }
  };

  init();
};

export default facturationAddress;